// Copyright (c) 2018 Deere & Company

import actions from '../actions-list';
import {addRemoveModalClass} from '../services/add-remove-modal-class';
import {getDefaultState as getExcelLayoutDefaultState} from '@deere/cps-it.warranty-model-factory/lib/excel-layout';
import {getDefaultState as getExcelLayoutSortByDefaultState} from '@deere/cps-it.warranty-model-factory/lib/excel-layout-sort-by';
import {getUpdatedSortBy} from '../components/excel-layout/services/get-updated-sort-by';
import {stripUnsafePathCharacters} from '../services/strip-unsafe';

export const pushExcelLayoutModalAvailableColumn = column => ({
    column,
    type: actions.PUSH_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMN
});

export const pushExcelLayoutModalExcelLayoutColumn = column => ({
    column,
    type: actions.PUSH_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_COLUMN
});

export const removeExcelLayoutModalAvailableColumn = index => ({
    index,
    type: actions.REMOVE_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMN
});

export const removeExcelLayoutModalExcelLayoutColumn = index => ({
    index,
    type: actions.REMOVE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_COLUMN
});

export const updateExcelLayoutModalAvailableColumns = availableColumns => ({
    availableColumns,
    type: actions.UPDATE_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMNS
});

export const updateExcelLayoutModalAvailableColumnsOrder = (dragIndex, hoverIndex, dragCard) => ({
    dragCard,
    dragIndex,
    hoverIndex,
    type: actions.UPDATE_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMNS_ORDER
});

export const updateExcelLayoutModalExcelLayout = (isNewLayout, excelLayout) => ({
    excelLayout: isNewLayout ? getExcelLayoutDefaultState() : excelLayout,
    type: actions.UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT
});

export const updateExcelLayoutModalExcelLayoutColumnsOrder = (dragIndex, hoverIndex, dragCard) => ({
    dragCard,
    dragIndex,
    hoverIndex,
    type: actions.UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_COLUMNS_ORDER
});

export const updateExcelLayoutModalExcelLayoutIsDefault = isDefault => ({
    isDefault,
    type: actions.UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_IS_DEFAULT
});

export const updateExcelLayoutModalExcelLayoutSortBy = (sortByColumn, existingSortBy) =>

    dispatch => {

        const sortByObject = existingSortBy.length ?
            existingSortBy[0] : getExcelLayoutSortByDefaultState();

        const updatedSortBy = getUpdatedSortBy(sortByColumn, sortByObject.direction);

        dispatch({
            sortBy: updatedSortBy,
            type: actions.UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_SORT_BY
        });

    };

export const updateExcelLayoutModalExcelLayoutSortDirection = (sortDirection, existingSortBy) =>

    dispatch => {

        const sortByObject = existingSortBy.length ?
            existingSortBy[0] : getExcelLayoutSortByDefaultState();

        const updatedSortBy = getUpdatedSortBy(sortByObject.column, sortDirection);

        dispatch({
            sortBy: updatedSortBy,
            type: actions.UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_SORT_DIRECTION
        });

    };

export const updateExcelLayoutModalIsNameValid = isNameValid => ({
    isNameValid,
    type: actions.UPDATE_EXCEL_LAYOUT_MODAL_IS_NAME_VALID
});
export const updateExcelLayoutModalIsNewLayout = (isNewLayout, listId) =>

    dispatch => {

        dispatch({
            listId,
            type: actions.UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_LIST_ID
        });

        dispatch({
            isNewLayout,
            type: actions.UPDATE_EXCEL_LAYOUT_MODAL_IS_NEW_LAYOUT
        });

    };

export const updateExcelLayoutModalLayoutName = name =>

    dispatch => {

        const processedName = stripUnsafePathCharacters(name);

        dispatch({
            name: processedName,
            type: actions.UPDATE_EXCEL_LAYOUT_MODAL_LAYOUT_NAME
        });

    };

export const updateExcelLayoutModalVisibility = isModalOpen =>

    dispatch => {

        addRemoveModalClass(isModalOpen);

        dispatch({
            isModalOpen,
            type: actions.UPDATE_EXCEL_LAYOUT_MODAL_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/shared/action-creators/excel-layout-modal.js